// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"

// ** Axios Imports
import api from "@src/api/config"

export const getTaxData = createAsyncThunk("taxtada/get", async (params) => {
    const response = await api.get(`api/taxdata/all/list`, {params})
    return {
      params,
      data: response.data
    }
})

export const wizardSlice = createSlice({
    name: "taxdata",
    initialState: {
        data: [], // data from backend
        response: [],
        modifyCert: {
          netPremium: 0
        }
    },
    reducers: {
      //
    },
    extraReducers: (builder) => {
      builder.addCase(getTaxData.fulfilled, (state, action) => {
        state.data = action.payload.data
      })
    }
})

export const { addWizardInfo } = wizardSlice.actions
  
export default wizardSlice.reducer